import React from 'react';
import { Card, Typography } from 'antd';

const { Title, Paragraph } = Typography;

const Welcome = () => {
  return (
    <Card>
      <Title level={2}>欢迎使用</Title>
      <Paragraph>你的账号已审批通过，但当前为普通用户权限。</Paragraph>
      <Paragraph>如需访问管理功能，请使用管理员账号登录。</Paragraph>
    </Card>
  );
};

export default Welcome;
